// react
import PropTypes from "prop-types";
import React from "react";

import { ModalButton, ModalContent } from "./ModalContent";

// components
import Modal from "../Modal/";

export default function ReviewTemplateModal(props) {
	const { handleTemplateInputChange, handleModalCancel, createReview } = props;

	return (
		<Modal
			handleClose={handleModalCancel}
			content={<ModalContent handleTemplateInputChange={handleTemplateInputChange} />}
			buttons={<ModalButton createReview={createReview} />}
		/>
	);
}

ReviewTemplateModal.propTypes = {
	handleTemplateInputChange: PropTypes.func.isRequired,
	handleModalCancel: PropTypes.func.isRequired,
	createReview: PropTypes.func.isRequired,
};
